export default __webpack_public_path__ + "static/media/ready.75d39dbc.jpg";